import { Box, Paper, Typography, Button } from "@mui/material";

export default function AuthError() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: "center" }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Authorization service unavailable
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          We couldn't reach the authorization service. This is usually
          temporary — please try again in a moment.
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </Paper>
    </Box>
  );
}
